import Vue from 'vue'
const vue = new Vue()
export default vue



// WEBPACK FOOTER //
// ./apps/comps/SignupModal/events.js